/*!
e
=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Group } from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { Person } from "@mui/icons-material";
import axios from "axios";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";

class Index extends React.Component {
  customNaam = (item) => {
    const voorvoegsel = item.Voorvoegsel !== null ? item.Voorvoegsel : "";
    const voornaam = item.Voornaam !== null ? item.Voornaam : "";
    const achternaam = item.Achternaam !== null ? item.Achternaam : "";

    return (voorvoegsel + " " + voornaam + " " + achternaam).replace("  ", "");
  };

  renderCustomNaam = (item) => {
    return item;
  };

  impersonate = (row) => {
    axios.post("/core/gebruikers/impersonate", { id: row[0] }).then((response) => {
      window.location.reload();
    });
  };

  rowColor = (item) => {
    console.log(item);
    return {
      backgroundColor: item.is_master ? "#a5f09e55" : "#ffffff00",
    };
  };

  render() {
    const { classes } = this.props;

    const actions = [];

    actions.push({
      icon: Person,
      tooltip: <TranslationWrapper tDefault={"Impersonate"} tKey={"gebruikers.table.tooltip.Impersonate"} />,
      action: this.impersonate,
      permissionKey: "impersonate",
    });

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Gebruikers overzicht"} tKey={"gebruikers.pagetitle"} />}
        />
        <GridContainer>
          <GridItem xs={12}>
            <Link to={"./create"}>
              <Button className={classes.marginRight} color={"success"}>
                <Add className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"Nieuwe gebruiker"} tKey={"gebruikers.nieuw.item"} />
              </Button>
            </Link>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"email"}
              fieldKey={"users:email"}
              operator={"like"}
              placeholder={getTranslation("gebruikers.filters.email", "Filter op email")}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "email", editable: false },
                { dbfield: "username", editable: false },
                { dbfield: "reseller.companyName", editable: false },
                {
                  customData: this.customNaam,
                  customRender: this.renderCustomNaam,
                },
                { dbfield: "profile.name", editable: false },
                // { dbfield: "is_master", editable: false },
              ]}
              delete={"gebruikers.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"gebruikers/:id/edit"}
              fetchUrl={"core/gebruikers"}
              filters={this.props.filters}
              headerIcon={<Group />}
              headers={[
                {
                  label: getTranslation("gebruikers.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("gebruikers.table.email", "Email"),
                  sortable: false,
                },
                {
                  label: getTranslation("gebruikers.table.gebruikersnaam", "Gebruikersnaam"),
                  sortable: true,
                  sortKey: "username",
                },
                {
                  label: getTranslation("gebruikers.table.reseller", "Reseller"),
                  sortable: false,
                },
                {
                  label: getTranslation("gebruikers.table.naam", "Naam"),
                  sortable: false,
                },
                {
                  label: getTranslation("gebruikers.table.profile", "Profile"),
                  sortable: false,
                },
                /* {
                                                                                   label: getTranslation("gebruikers.table.is_master", "Master"),
                                                                                   sortable: false,
                                                                                 },*/
              ]}
              reduxKey={"gebruikers"}
              rowConditionalStyle={this.rowColor}
              tableTitle={<TranslationWrapper tDefault={"Gebruikers"} tKey={"gebruikers.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["users:email"]) {
    filters["users:email"] = state.filtersV2["users:email"];
  }
  return {
    filters,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
